import React, { useEffect, useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import PopularDestinationListItem from "./PopularDestinationListItem";
import { getPopularDestinations } from "@/src/actions/tour/tourAction";

const DEFAULT_SKELETONS = 6;

function SkeletonGrid({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="overflow-hidden rounded-xl border bg-card shadow-sm"
        >
          <Skeleton className="h-44 w-full" />
          <div className="p-4 space-y-2">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-5/6" />
            <Skeleton className="h-8 w-24" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default function PopularDestinations({
  skeletonCount = DEFAULT_SKELETONS,
  onSelect, // optional callback (destination) => void
}) {


  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPopularDestinations((data) => {
      setDestinations(data);
      setLoading(false);
    })
  }, []);

  // ✅ loading skeletons
  // Loading: show skeletons (section visible)
  if (loading) {
    return (
      <section className="space-y-4">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h2 className="text-lg md:text-xl font-semibold tracking-tight">
              Popular Destinations
            </h2>
            <p className="text-sm text-muted-foreground">
              Explore places travellers love right now
            </p>
          </div>
        </div>

        <SkeletonGrid count={skeletonCount} />
      </section>
    );
  }

  // Not loading + empty: invisible DOM
  if (!Array.isArray(destinations) || destinations.length === 0) return null;

  return (
    <section className="space-y-4">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="text-lg md:text-xl font-semibold tracking-tight">
            Popular Destinations
          </h2>
          <p className="text-sm text-muted-foreground">
            Explore places travellers love right now
          </p>
        </div>

        {/* Optional “View all” button if you want later */}
        {/* <Button variant="outline" size="sm">View all</Button> */}
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {destinations.map((d) => (
          <PopularDestinationListItem
            key={d?.DestinationID}
            destination={d}
          />
        ))}
      </div>
    </section>
  );
}